import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const { CLICK } = SNOWPLOW_EVENTS;

export const triggerSellerMessagingBodyInputClickedEvent = (): void => {
	const eventPayload = getSnowplowEventPayload({
		category: ANALYTICS_CATEGORIES.ACCOUNT.SELLER_MESSAGING,
		name: 'dlr_seller_messaging_body_input_clicked',
		schemaName: CLICK.SCHEMA,
		version: CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
